import React, { useEffect } from 'react';
import { LandingPage } from './components/LandingPage';
export function App() {
  useEffect(() => {
    document.title = 'BEAT - A Sober Soda, Done Right';
  }, []);
  return <LandingPage data-id="element-0" />;
}